import { Table } from '@chakra-ui/react/table';

import { DecoratedArtifact } from '@/models/Artifact';

import ArtifactTrackingProvider from '../../ArtifactTrackingProvider/ArtifactTrackingProvider';
import ArtifactRow from './ArtifactRow/ArtifactRow';

type Props = {
  artifacts: DecoratedArtifact[];
  appSlug: string | undefined;
  buildSlug: string | undefined;
  triggeredWorkflow: string | undefined;
  caption: string;
  isTableCaptionVisible?: boolean;
};

const OtherArtifactsTable = ({
  artifacts,
  appSlug,
  buildSlug,
  triggeredWorkflow,
  caption,
  isTableCaptionVisible,
}: Props) => {
  if (!artifacts.length) {
    return null;
  }

  return (
    <Table.ScrollArea>
      <Table.Root>
        {isTableCaptionVisible && (
          <Table.Caption color="text/primary" marginBlockEnd="12" textStyle="heading/h3">
            {caption}
          </Table.Caption>
        )}

        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="48" />
            <Table.ColumnHeader>Name</Table.ColumnHeader>
            <Table.ColumnHeader width="12rem" />
            <Table.ColumnHeader width="10rem">Size</Table.ColumnHeader>
            <Table.ColumnHeader width="14rem" />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {artifacts.map((artifact, index) => {
            const { id: artifactId } = artifact;
            const key = `${artifactId}-${index}`;
            const slug = artifact?.build?.slug || buildSlug;
            const workflowName = artifact?.build?.triggeredWorkflow || triggeredWorkflow || '';

            return (
              <ArtifactTrackingProvider key={key} appSlug={appSlug} buildSlug={slug} artifactSlug={artifact.slug}>
                <ArtifactRow appSlug={appSlug} artifact={artifact} workflowName={workflowName} />
              </ArtifactTrackingProvider>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};

export default OtherArtifactsTable;
